/** web-highlighter 文本标注文档地址:
https://github.com/alienzhou/web-highlighter/blob/master/README.zh_CN.md */
<!-- 训练模型-文本标注区 -->
<template>
  <div class="text-annotation-area">
    <div class="text-annotation-examples cannotLabel" :class="{ 'events-disable': isRelease == 1 }">
      <span @click="activeExamplePopup">标注示例</span>
    </div>
    <!-- <div
      ref="content"
      id="textDataview"
      class="text-annotation-content"
      v-html="dataview"
    ></div> -->
    <div id="text-webHighlighter">
      <div
        ref="content"
        id="textDataview"
        class="text-annotation-content"
        :class="{ 'text-events-disable': isRelease == 1 }"
      >
        <p
          v-for="(item, index) in textList"
          :key="index"
          @mousedown="textCurrentRow(index)"
          v-html="item"
        ></p>
      </div>
    </div>

    <div class="popup-list cannotLabel">
      <!-- 标注示例 -->
      <gat-popup
        :class="['popup-example', popupActive === 'example' ? 'on' : 'off']"
        :title="'标注示例'"
        @cancel="cancelPopup"
      >
        <template v-slot:content>
          <div class="example-box">
            <img
              src="../../../public/images/pretrain/annotation-examples.png"
              alt=""
            />
            <!-- <div class="label-column label-all">
              <div class="txt">
                同一张图中需要标注“<b>全部想要标识的目标区域</b>” <br />
                以“检测一张图中所有的猫”为例：
              </div>
              <img src="../../../public/images/pretrain/annotation-examples.png" alt="" />
            </div> -->
            <!-- <div class="label-column label-similar">
              <div class="txt">
                <b>标注文本需要和实际场景一致，</b>” <br />
                以实际场景为识别出“用手机在超市货架拍摄的图片”中有几层货架为例：
              </div>
              <img :src="Example.labelSimilarImg" alt="" />
            </div> -->
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import PRETRAIN from '@/axios/pretrain/pretrain.js'
import { GetText } from '@/assets/js/mixin/mixinGetTextStr.js'
import GatPopup from '@/components/common/GatPopup'

/**
 * 解析获取.txt文本
 * zlh
 * @plugin chardet: chardet.detect 用于解析文本是什么编码格式
 */
import chardet from 'chardet'

import Highlighter from 'web-highlighter'
// import Highlighter from '@/assets/js/pretrain/web-highlighter';
// import LocalStore from '@/assets/js/pretrain/local.store.js';

export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'TextAnnotationArea',
  mixins: [GetText],
  components: { GatPopup },
  props: {
    origin: {
      type: String,
      default: '',
    },
    isRelease: {
      type: Number,
      default: null,
    },
    labelList: {
      type: Array,
      default: () => [],
    },
    annotationsList: {
      type: Array,
      default: () => [],
    },
    regionText: {
      // 当前文件
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      popupActive: '',
      dataview: '', // 解析的所有文本
      selectedText: '', // 选中的文本
      textList: [], // 文本所有段落列表
      selectedTextAll: [], // 返回的标注列表
      identicalText: '', // 重叠的文字
      searchValue: '', // 搜索标注的文本
      lastTextTagId: '', // 上次搜索的id
      textRowIndex: null, // 当前选中行下标
      selectLabel: '', // 选中标签
      highlighter: null,
      localRegion: [], // 缓存当前添加的未保存标注
      deleteTextTagIds: [], // 缓存当前删除的标注id
      localTextId: '',
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    // 监听切换文本
    regionText(val) {
      if (this.highlighter) {
        this.highlighter.dispose()
      }

      // if (val && val.textId !== this.localTextId) { // 相同文本只执行一次
      // this.localTextId = val.textId
      if (localStorage.localRegion) {
        // 有数据则是删除标签后缓存的未保存标注数据
        this.localRegion = JSON.parse(localStorage.localRegion)
        localStorage.localRegion = ''
      } else {
        this.localRegion = [] // 切换文本清空当前缓存标注
        this.deleteTextTagIds = [] // 清空缓存删除的标注id
      }

      // this.deleteTextTagIds = []; // 清空缓存删除的标注id
      // }

      this.textList = [] // 清空文本区
      // 切换文件文本区滚动置顶
      document.getElementById('textDataview').scrollTop = 0
      // 切换文件删除上次文件标注所有的span标签
      document
        .querySelectorAll('#textDataview span')
        .forEach((item) => item.remove())
      if (val && val.textUrl) {
        this.regionText = val
        this.getText() // 获取文本方法
      } else {
        this.dataview = ''
      }
    },
    selectedTextAll(val) {
      this.selectedTextAll = val
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let _this = this
    // 文本区鼠标弹起事件
    this.$refs.content.addEventListener('mouseup', function() {
      // isRelease ==1时为已发布的文本数据集
      if (_this.isRelease != 1) {
        // 获取鼠标选中的文字
        let selectedText = window.getSelection
          ? window.getSelection().toString()
          : document.selection.createRange().text

        _this.selectedText = selectedText.replace(/^\s+|\s+$/g, '') // 去除前后空格、换行

        _this.highlighter.stop() // 关闭自动划词高亮标注
        if (_this.selectedText) {
          if (_this.selectLabel && _this.selectLabel.labelName) {
            if (_this.selectedText.length > 200) {
              return _this.$message.error('文本标注内容不得超过200个字符！')
            }

            let flng = false
            _this.selectedTextAll.forEach((item) => {
              if (
                item.labelName !== _this.selectLabel.labelName &&
                item.tagValue === _this.selectedText
              ) {
                flng = true
              }
            })

            if (flng) {
              return _this.$message.error(
                '该文本已有标注标签，不可标注其他标签！'
              )
            }
            _this.highlighter.run() // 开启自动划词高亮标注。
          } else {
            _this.$message.error('请选择标签！')
          }
        }
      }
    })
  },

  methods: {
    // 获取文本
    getText(val) {
      this.textList = [] // 清空文本区
      if (this.regionText && this.regionText.textUrl) {
        let filePath = this.photoBaseUrl + this.regionText.textUrl
        this.getTxtContent(filePath)
      }
    },
    /**
     * 通过url获取文本内容
     */
    getTxtContent(url) {
      let getTextStr
      let fileReader
      this.$axios({
        method: 'get',
        url: url,
        responseType: 'blob',
      }).then(async (res) => {
        let blob = res
        let encoding = ''
        try {
          encoding = await this.getTextEncoding(blob)
        } catch (e) {
          // console.log(e)
          encoding = 'gbk'
        }
        fileReader = new FileReader()
        fileReader.readAsText(blob, encoding || 'gbk')
        fileReader.onloadend = (e) => {
          getTextStr = e.target.result
          getTextStr = getTextStr.replace(/\n|\r\n/g, '<br/>')

          this.textHandler(getTextStr) // 处理文本渲染
        }
      })
    },
    /**
     * 获取编码格式
     * @param blob
     * @returns {Promise<any>}
     */
    getTextEncoding(blob) {
      return new Promise((resolve, reject) => {
        let readerArrayBuffer = new FileReader()
        readerArrayBuffer.readAsArrayBuffer(blob)
        readerArrayBuffer.onload = (e) => {
          let encoding = ''
          let arrayBuffer = e.target.result
          let uint8Array = new Uint8Array(arrayBuffer)
          let char = chardet.detect(uint8Array).toLocaleLowerCase()
          // console.log('char',char)
          if (!uint8Array || uint8Array.length < 3) return (this.txt = '')

          if (char.includes('utf')) {
            encoding = 'UTF-8'
          } else {
            encoding = 'GB2312'
          }
          resolve(encoding)
        }
        readerArrayBuffer.onerror = reject
      })
    },
    // 切换文件 — 处理文本渲染
    textHandler(val) {
      if (val) {
        let dataview = val.split('<br/>')
        let textList = []
        dataview.forEach((item) => {
          if (item && item.length !== 0) {
            textList.push(item.replace(/^\s+|\s+$/g, ''))
          } else {
            // textList.push('<br/>')
          }
        })
        this.textList = textList

        // 切换文件文本区滚动置顶
        document.getElementById('textDataview').scrollTop = 0
        // 切换文件删除上次文件标注所有的span标签
        document
          .querySelectorAll('#textDataview span')
          .forEach((item) => item.remove())
        this.$forceUpdate() // 强制更新数据

        this.selectedText = '' // 清空选中文本
      }
    },

    // 外部调用-渲染标注
    getAnnotationsList(val) {
      // console.log('返回标注列表',val)
      if (val) {
        let selectedTextAll = JSON.parse(JSON.stringify(val))
        let tagChildren = {}
        // 标注返回的数据同步tagChildren里的数据
        selectedTextAll.forEach((item) => {
          tagChildren = JSON.parse(item.tagChildren)
          tagChildren.id = item.textTagId
          tagChildren.textTagId = item.textTagId
          tagChildren.labelColor = item.labelColor
          tagChildren.labelName = item.labelName
          tagChildren.labelId = item.labelId
          tagChildren.isShow = item.isShow
          item.tagChildren = JSON.stringify(tagChildren)
        })

        this.selectedTextAll = selectedTextAll
        this.selectedText = ''
      }
      if (val && val.length === 0) {
        this.selectedTextAll = []
      }

      setTimeout(() => {
        this.webHighlighter()
      }, 100)
    },

    /**
     * 当前标注高亮
     * @id '当前标注id'
     * @spanList Array[<文本区所有的span标注>]
     * @selectedTextAll Array[{存储标注数据}]
     */
    currentColorHighlight(id, spanList, selectedTextAll) {
      let labelColor = ''
      let tagChildren = {}
      let list = Array.from(spanList)
      selectedTextAll.forEach((item) => {
        tagChildren = JSON.parse(item.tagChildren)
        if (tagChildren.textTagId == id) {
          labelColor = tagChildren.labelColor // 获取当前标注颜色
        }
      })
      list.forEach((item) => {
        if (item.className.indexOf(id) !== -1) {
          item.style.backgroundColor = labelColor // 高亮当前标注相同的id标签
        }
        let spanSonId = item.getAttribute('data-id')
        if (spanSonId === id) {
          item.style.zIndex = '3'
        }
      })
    },
    /**
     * 复原标注样式
     * @id '当前标注id'
     * @spanList Array[<文本区所有的span标注>]
     * @selectedTextAll Array[{存储标注数据}]
     */
    labelColorRecovery(id, spanList, selectedTextAll) {
      let tagIndex = 0
      let tagChildren = {}
      let list = Array.from(spanList)
      list.forEach((item) => {
        if (item.className.indexOf(id) !== -1) {
          // 过滤出当前的标签
          selectedTextAll.forEach((i) => {
            tagChildren = JSON.parse(i.tagChildren)
            if (item.className.indexOf(tagChildren.textTagId) !== -1) {
              // 判断每个标签有多少标注id
              if (tagChildren.tagIndex >= tagIndex) {
                // 相同的标注标签多个id取最高层级
                tagIndex = tagChildren.tagIndex
                item.style.backgroundColor = tagChildren.labelColor // 复原标注标签颜色
              }
            }
          })
        }
        let spanSonId = item.getAttribute('data-id')
        if (spanSonId === id) {
          item.style.zIndex = '0'
        }
      })
    },

    // 标注、渲染处理
    webHighlighter() {
      let _this = this

      const highlighter = new Highlighter({
        $root: document.getElementById('text-webHighlighter'),
        wrapTag: 'span',
        exceptSelectors: ['.my-remove-tip', 'pre', 'code', '.cannotLabel'],
        // style: {
        //   className: 'highlight-mengshou-wrap'
        // }
      })

      this.highlighter = highlighter

      /**
       * 创建提示标签，可删除当前标注
       */
      const createTag = (top, left, id, item) => {
        const $span = document.createElement('span')
        $span.style.width = `${item.labelName.length + 2}em`
        $span.style.left = `${left - 20}px`
        $span.style.top = `${top - 25}px`
        // $span.style.display = 'none'
        $span.style.backgroundColor = item.labelColor || ''
        $span.textContent = item.labelName || '删除'
        $span.style.zIndex = '0'
        $span.dataset['id'] = id
        $span.classList.add('my-remove-tip')

        const $i = document.createElement('i')
        $i.textContent = 'ｘ'
        $i.style.fontSize = '16px'
        $i.style.fontStyle = 'normal'
        $i.style.float = 'right'
        $i.dataset['id'] = id
        $i.classList.add('my-delete-tip')
        $span.appendChild($i)

        let textDataview = document.getElementById('textDataview')
        let spanList = textDataview.getElementsByTagName('span')

        // 移入提示框标签, 显示对应的标注高亮
        $span.onmouseover = function(e) {
          $span.style.zIndex = '3'
          _this.currentColorHighlight(id, spanList, _this.selectedTextAll) // 当前标注高亮
        }
        // 移出提示框标签, 复原标注
        $span.onmouseleave = function(e) {
          $span.style.zIndex = '0'
          _this.labelColorRecovery(id, spanList, _this.selectedTextAll) // 复原标注样式
        }

        document.getElementById('textDataview').appendChild($span) // 给标注追加创建的提示标签
      }

      // 处理提示区渲染位置
      function getPosition($node) {
        let offset = {
          top: 0,
          left: 0,
        }
        offset.top = $node.offsetTop
        offset.left = $node.offsetLeft
        return offset
      }

      /**
       * 荧光笔事件侦听器
       */
      highlighter
        .on(Highlighter.event.CLICK, ({ id }) => {
          // 点击高亮区域
        })
        .on(Highlighter.event.HOVER, ({ id }) => {
          // 鼠标移至高亮区域
          let textDataview = document.getElementById('textDataview')
          let spanList = textDataview.getElementsByTagName('span')

          _this.currentColorHighlight(id, spanList, _this.selectedTextAll) // 当前标注高亮

          // highlighter.addClass('highlight-wrap-hover', id);
        })
        .on(Highlighter.event.HOVER_OUT, ({ id }) => {
          // 鼠标移出高亮区域
          let textDataview = document.getElementById('textDataview')
          let spanList = textDataview.getElementsByTagName('span')

          _this.labelColorRecovery(id, spanList, _this.selectedTextAll) // 复原标注样式

          // highlighter.removeClass('highlight-wrap-hover', id);
        })
        .on(Highlighter.event.CREATE, ({ sources }) => {
          // 高亮区域被创建
          // console.log('create -', sources);
          let textDataview = document.getElementById('textDataview')
          let spanList = textDataview.getElementsByTagName('span')
          spanList = Array.from(spanList)

          sources.forEach((s) => {
            let tagIndex = 0
            let textChildren

            if (_this.selectedText) {
              // 选中文本标注重叠处理层级
              _this.selectedTextAll.forEach((item) => {
                textChildren = JSON.parse(item.tagChildren)
                if (textChildren.tagValue.indexOf(s.text) !== -1) {
                  tagIndex = textChildren.tagIndex + 1
                }
                if (s.text.indexOf(textChildren.tagValue) !== -1) {
                  tagIndex = textChildren.tagIndex
                  textChildren.tagIndex = tagIndex + 1
                  highlighter.addClass(
                    `classname${item.textTagId}`,
                    item.textTagId
                  ) // 给标注添加类名
                }
                item.tagChildren = JSON.stringify(textChildren)
              })
            }

            s.textId = _this.regionText.textId // 文件id
            s.labelId = _this.selectLabel.labelId // 标签id
            s.textTagId = s.id // 标注文本的id
            s.labelName = _this.selectLabel.labelName // 标签名字
            s.labelColor = _this.selectLabel.labelColor // 标签颜色
            s.tagValue = s.text // 选中的文本
            s.tagHeight = _this.textRowIndex // 文本当前标注行下标
            s.tagIndex = tagIndex // 层级

            let children = JSON.stringify(s)
            s.tagChildren = children

            if (_this.selectedText) {
              // 选中文本标注
              let textItem = JSON.parse(JSON.stringify(s))
              _this.selectedTextAll.push(textItem)
              _this.localRegion.push(textItem) // 缓存当前创建的标注
            } else {
              // 无选中文本，取返回的标注
              _this.selectedTextAll.forEach((item) => {
                if (item.textTagId.indexOf(s.id) !== -1) {
                  let tagChildren = JSON.parse(item.tagChildren)
                  s = tagChildren
                }
              })
            }

            highlighter.addClass(`classname${s.id}`, s.id) // 给标注添加类名

            spanList.forEach((item) => {
              if (item.className.indexOf(s.id) !== -1) {
                item.style.backgroundColor = s.labelColor || ''
              }
            })
            // _this.labelColorRecovery(s.id, spanList, _this.selectedTextAll) // 复原标注样式

            // setTimeout(() => {
            //   let zIndex = 0
            //   let child

            //   spanList.forEach(item => {
            //     _this.selectedTextAll.forEach(i => {
            //       if (item.className.indexOf(i.textTagId) !== -1) {
            //         child = JSON.parse(i.tagChildren)
            //         if (child.tagIndex >= zIndex) { // 判断最高层级
            //           zIndex = child.tagIndex
            //           item.style.backgroundColor = child.labelColor // 修改标注高亮颜色
            //         }
            //       }
            //     });
            //   });
            // }, 200);

            const position = getPosition(highlighter.getDoms(s.id)[0])
            createTag(position.top, position.left, s.id, s) // 创建标注提示框
          })
          if (sources.length === 0) {
            // console.log('不创建')
            let zIndex = 0
            let tagChildren
            spanList.forEach((item) => {
              let spanSonId = item.getAttribute('data-id')
              _this.selectedTextAll.forEach((i) => {
                if (spanSonId === i.textTagId) {
                  item.style.width = `${i.labelName.length + 2}em` // 修改提示区宽
                  item.childNodes[0].nodeValue = i.labelName // 修改提示区标签名
                }
                // if (item.className.indexOf(i.textTagId) !== -1) {
                //   tagChildren = JSON.parse(i.tagChildren)
                //   if (tagChildren.tagIndex >= zIndex) { // 判断最高层级
                //     zIndex = tagChildren.tagIndex
                //     item.style.backgroundColor = i.labelColor // 修改标注高亮颜色
                //   }
                // }
              })
            })
          }
          highlighter.stop() // 关闭自动划词高亮标注
          _this.selectedText = '' // 创建标注完毕清空选中文本
        })
        .on(Highlighter.event.REMOVE, ({ ids }) => {
          // 高亮区域被清除
          // console.log('remove -', ids);
          ids.forEach((id) => {
            // setTimeout(() => {
            // _this.selectedTextAll.forEach((item, index) => {
            //   if (item.textTagId == id) {
            //     _this.selectedTextAll.splice(index, 1) // 删除标注
            //   }
            // });
            // }, 200);
          })
        })

      highlighter.hooks.Serialize.Restore.tap((source) => {
        // console.log('Serialize.Restore hook -', source)
      })

      highlighter.hooks.Serialize.RecordInfo.tap(() => {
        const extraInfo = Math.random().toFixed(4)
        // console.log('Serialize.RecordInfo hook -', extraInfo)
        return extraInfo
      })

      let textAll = _this.localRegion.concat(_this.selectedTextAll) // 未保存的标拼接返回的标注
      _this.selectedTextAll = _this.arrUnique(textAll) // 标注列表去重
      _this.selectedTextAll.forEach((r) => {
        r.isShow = 0 // 所有标注默认不显示
      })
      _this.labelList.forEach((item) => {
        // 遍历标签列表
        _this.selectedTextAll.forEach((r) => {
          if (item.labelName === r.labelName) {
            // 判断标签对应的标注
            r.isShow = item.labelState ? 1 : 0 // 标签勾选显示隐藏标注状态：1 显示，0 不显示
          }
        })
      })

      // 从全部标注中移除当前删除的标注
      _this.deleteTextTagIds.forEach((i) => {
        _this.selectedTextAll.forEach((r, index) => {
          if (i == r.textTagId) {
            // 判断标签对应的标注
            _this.selectedTextAll.splice(index, 1)
          }
        })
      })

      // highlighter.removeAll() // 删除所有标注
      // 渲染返回的标注
      _this.selectedTextAll.forEach((item) => {
        let hs = JSON.parse(item.tagChildren)
        if (item.isShow === 1) {
          // 判断是否显示隐藏标注
          highlighter.fromStore(
            hs.startMeta,
            hs.endMeta,
            hs.text,
            hs.textTagId,
            hs.extra
          ) // 调用渲染标注方法
        }
      })

      // 点击提示“ｘ”删除标注
      document.getElementById('textDataview').addEventListener('click', (e) => {
        // if (this.isRelease != 1 && this.origin != 'modelList') {
          const $ele = e.target
          // 删除突出显示
          if ($ele.classList.contains('my-delete-tip')) {
            const id = $ele.dataset.id

            // highlighter.removeClass('highlight-wrap-hover', id);
            highlighter.remove(id) // 删除高亮标注

            if ($ele.parentNode && $ele.parentNode.parentNode) {
              $ele.parentNode.parentNode.removeChild($ele.parentNode) // 删除当前元素的父节点提示框标签

              let tagIndex = 0
              let tagChildren = {}
              let classname = 'classname' + id
              highlighter.removeClass(classname, id) // 移除类

              let textDataview = document.getElementById('textDataview')
              let spanList = textDataview.getElementsByTagName('span')
              spanList = Array.from(spanList)
              spanList.forEach((item) => {
                if (item.className.indexOf(id) !== -1) {
                  // highlighter.removeClass(classname, id) // 移除类
                  item.classList.remove(classname) // 删除类名
                }
                _this.selectedTextAll.forEach((i) => {
                  tagChildren = JSON.parse(i.tagChildren)
                  if (item.className.indexOf(tagChildren.textTagId) !== -1) {
                    if (tagChildren.tagIndex >= tagIndex) {
                      tagIndex = tagChildren.tagIndex
                      item.style.backgroundColor = tagChildren.labelColor
                    }
                  }
                })
              })
              // 从数组里移除标注
              _this.selectedTextAll.forEach((i, index) => {
                if (i.textTagId == id) {
                  _this.selectedTextAll.splice(index, 1)
                }
              })

              // 删除当前添加的缓存标注
              _this.localRegion = _this.localRegion.filter(function(r) {
                if (r.textTagId == id) return false
                return true
              })

              _this.deleteTextTagIds.push(id) // 缓存当前删除的标注id
            }
          }
          // 手动高亮显示范围
          // else if ($ele.id === 'js-highlight') {
          //   const selection = window.getSelection();
          //   if (selection.isCollapsed) {
          //     return;
          //   }
          //   highlighter.fromRange(selection.getRangeAt(0));
          //   window.getSelection().removeAllRanges();
          // }
        // }
      })

      let hoveredTipId
      document.addEventListener('mouseover', (e) => {
        const $ele = e.target
        // 切换突出显示悬停状态
        if (
          $ele.classList.contains('my-remove-tip') &&
          hoveredTipId !== $ele.dataset.id
        ) {
          hoveredTipId = $ele.dataset.id
          highlighter.removeClass('highlight-wrap-hover')
          highlighter.addClass('highlight-wrap-hover', hoveredTipId)
        } else if (
          !$ele.classList.contains('my-remove-tip') &&
          !$ele.classList.contains('highlight-mengshou-wrap')
        ) {
          highlighter.removeClass('highlight-wrap-hover', hoveredTipId)
          hoveredTipId = null
        }
      })
    },

    // 标注去重
    arrUnique(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i].textTagId == arr[j].textTagId) {
            arr.splice(j, 1)
            j--
          }
        }
      }
      return arr
    },

    // 外部调用-选中标签
    addLabelSelect(val) {
      this.selectLabel = val
    },

    // 外部调用-定位到标注位置
    onCurrentTextValue(searchValue, textTagId) {
      let dataview = document.getElementById('textDataview')

      // 还原上次搜索定位标注样式
      if (this.lastTextTagId && this.lastTextTagId !== textTagId) {
        let spanList = dataview.querySelectorAll(`.classname${this.lastTextTagId}`) // 获取当前所有相同的标注
        this.labelColorRecovery(this.lastTextTagId, spanList, this.selectedTextAll) // 复原标注样式
      }

      // 高亮当前搜索定位标注
      if (searchValue && textTagId) {
        this.lastTextTagId = textTagId // 存储当前搜索id

        let addSpanlist = []
        let textList = this.selectedTextAll.filter((item) => {
          if (item.tagValue === searchValue) {
            addSpanlist = dataview.querySelectorAll(`.classname${textTagId}`) // 获取当前所有相同的标注
          }
          return item.textTagId === textTagId || item.tagValue === searchValue
        })
        let labelColor = textList[0].labelColor // 获取当前标注颜色

        if (addSpanlist.length !== 0) {
          let spanId = addSpanlist[0]
          spanId.setAttribute('id', 'locationAnnotation')
          //跳转到id位置
          let ele = document.getElementById('locationAnnotation')
          ele.scrollIntoView({
            block: 'center',
            behavior: 'auto',
            inline: 'start',
          })

          // 显示当前定位标注文本高亮
          addSpanlist.forEach((item) => {
            if (item.className.indexOf(textTagId) !== -1) {
              item.style.backgroundColor = labelColor
            }
          })

          //清除id
          spanId.setAttribute('id', '')
        }
      }
    },

    // 外部调用-保存标注列表
    stypeToTextList() {
      return this.selectedTextAll
    },

    // 外部调用标签重命名同步标注名称
    renameRegionLabel(newlabelName, oldlabelName) {
      var list = JSON.parse(JSON.stringify(this.selectedTextAll)),
        newList = list.map((region) => {
          var temp = region
          if (region.labelName === oldlabelName) {
            region.labelName = newlabelName
            region.isShow = 1
            let tagChildren = JSON.parse(region.tagChildren)
            tagChildren.labelName = newlabelName
            tagChildren.isShow = region.isShow
            region.tagChildren = JSON.stringify(tagChildren)
          }
          return temp
        })
      this.selectedTextAll = newList

      var localRegion = JSON.parse(JSON.stringify(this.localRegion)),
        regionList = localRegion.map((region) => {
          var temp = region
          if (region.labelName === oldlabelName) {
            region.labelName = newlabelName
            region.isShow = 1
            let tagChildren = JSON.parse(region.tagChildren)
            tagChildren.labelName = newlabelName
            tagChildren.isShow = region.isShow
            region.tagChildren = JSON.stringify(tagChildren)
          }
          return temp
        })
      this.localRegion = regionList

      // 外部调用，使用 $refs 不是响应式系统，需要进行强制更新
      this.$forceUpdate()
      setTimeout(() => {
        this.webHighlighter() // 更新标注
      }, 100)
    },

    // 标签删除
    deleteRegionLabel(removelabelName) {
      var list = JSON.parse(JSON.stringify(this.selectedTextAll)),
        newList = list.filter((region) => {
          var temp = region
          if (region.labelName !== removelabelName) {
            return temp
          }
        })
      this.selectedTextAll = newList

      var localRegion = JSON.parse(JSON.stringify(this.localRegion)),
        regionList = localRegion.filter((region) => {
          var temp = region
          if (region.labelName !== removelabelName) {
            return temp
          }
        })
      this.localRegion = regionList
      localStorage.localRegion = JSON.stringify(regionList) // 未保存的标注中缓存未删除的标注
      // 外部调用，使用 $refs 不是响应式系统，需要进行强制更新
      this.$forceUpdate()
    },

    // 获取当前行下标
    textCurrentRow(rowIndex) {
      this.textRowIndex = rowIndex
    },

    // 排序
    bubbleSort(arr) {
      var len = arr.length
      for (var i = 0; i < len; i++) {
        for (var j = 0; j < len - 1 - i; j++) {
          if (arr[j].tagValue.length < arr[j + 1].tagValue.length) {
            //相邻元素两两对比,大到小
            var temp = arr[j + 1] //元素交换
            arr[j + 1] = arr[j]
            arr[j] = temp
          }
        }
      }
      return arr
    },

    // 判断首尾重叠标注、获取重叠文本
    mixinRepeatKeywords(k1, k2, sign) {
      /**
       * 去重合并关键词
       * @param   {String} k1 关键词1
       * @param   {String} k2 关键词2
       * @returns {String, Boolean} 返回匹配后的新字符串
       * @TODO:
       */
      if (k1 === k2 || !k2 || !k1) return false

      const len1 = k1.length
      const len2 = k2.length
      let index = 0

      // 合并唯一
      for (let i = 1; i < len1; i++) {
        let sub1 = k1.substring(len1 - i, len1) // k1的后几位
        let sub2 = k2.substring(0, i) // k2的前几位

        // 记录匹配上的最后一个位置
        if (sub1 === sub2) {
          this.identicalText = sub1 // 重叠的文字
          index = i
        }
      }

      // 拼接为一个字符串
      if (index) {
        // return k1 + k2.substring(index, len2)
        return index
      }

      // 互换以后不再进行递归处理
      if (sign) {
        return false
      } else {
        // 互换位置
        return this.mixinRepeatKeywords(k2, k1, true)
      }
    },

    // 标注示例
    activeExamplePopup() {
      this.popupActive = 'example'
    },
    cancelPopup() {
      this.popupActive = ''
    },
  },
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    // this.highlighter.stop() // 关闭自动划词高亮
  },
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import './pretrain_common.scss';
div {
  box-sizing: border-box;
}

.text-annotation-area {
  width: 710px;
  height: 500px;
  border: 1px solid #dde5f7;
  .text-annotation-examples {
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    span {
      float: right;
      color: #4c88ff;
      cursor: pointer;
    }
  }

  .popup-list {
    .popup-example {
      .example-box {
        padding: 20px 0;
        display: flex;
        justify-content: center;
        // align-items: center;
        img {
          width: 840px;
          height: 350px;
        }
      }
    }
    ::v-deep.popup-inner .popup-buttons {
      display: none;
    }
  }

  .text-annotation-content {
    width: 670px;
    height: 430px;
    background-color: rgba(51, 51, 51, 0.1);
    border: 1px solid #ccc;
    margin: 0 20px;
    padding: 20px 10px;
    overflow: auto;
    position: relative;
    p {
      line-height: 42px;
      text-indent: 2em;
    }
  }
}
</style>

<style lang="scss">
.text-annotation-content {
  position: relative;

  .highlight-mengshou-wrap {
    position: relative;
  }

  .highlight-wrap-hover {
    background: #f7aaaa;
    position: relative;
  }

  .my-remove-tip {
    box-sizing: border-box;
    position: absolute;
    border: 1px solid #fff;
    border-radius: 3px;
    height: 20px;
    width: 60px;
    color: #fff;
    background: #444;
    text-align: center;
    // text-align: left;
    font-size: 12px;
    cursor: pointer;
    line-height: 18px;
    overflow: visible;
    text-indent: 0;
  }

  .my-remove-tip::after {
    content: '';
    position: absolute;
    left: 16px;
    bottom: -4px;
    border-color: #444 transparent transparent;
    border-width: 4px 4px 0;
    border-style: solid;
    height: 0;
    width: 0;
  }

  .addSpan {
    // background-color: skyblue;
    position: relative;
    i {
      font-style: normal;
    }
    .test-span {
      background-color: '#C67D03' !important;
    }
    .addI {
      display: none;
    }
    &:hover {
      // z-index: 9 !important;
      .addI {
        position: absolute;
        height: 20px;
        border: 1px solid #ccc;
        border-radius: 4px;
        line-height: 20px;
        padding: 0 3px;
        top: -22px;
        left: 0;
        text-indent: 0;
        // transform: translateX(-50%);
        .icon-fork {
          float: right;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  &.text-events-disable {
    opacity: 1;
    > p,
     span {
     // opacity: .1;
      pointer-events: none;
      cursor: default;
    }
  }
}
</style>
